import { Routes, Route, Navigate } from 'react-router-dom';
import PressureTest from './pages/PressureTest';
import Privacy from './pages/Privacy';
import Footer from './components/Footer';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-paper text-ink-soft">
      <main className="flex-1">
        <Routes>
          {/* pressuretest.sagentivum.com → root is the funnel */}
          <Route path="/" element={<PressureTest />} />
          <Route path="/privacy" element={<Privacy />} />
          {/* Legacy /pressuretest path kept as a redirect - any external links
              that get cut after the subdomain decision will still resolve. */}
          <Route path="/pressuretest" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
